import { Component, ElementRef, ViewChild } from '@angular/core';
import { PageBase, RentalObjectInfo } from 't4core';
import { CreateServiceRequestDialog, T4DatatableWidget, ObjectDialog } from '../../../../t4common/';
import { CreateObjectDialog } from '../../dialogs/CreateObjectDialog/CreateObjectDialog';




@Component({
    selector: 'objects',
    styleUrls: ['./objects.component.css'],
    templateUrl: './objects.component.html',
})
export class ObjectsComponent extends PageBase {

  @ViewChild("datatable", {static: false}) table: T4DatatableWidget;


   constructor(el: ElementRef) {
        super(el, "FleetManager");
  }

    public async reenable(item: RentalObjectInfo) {
        var x = await this.UI.confirm("Turbo.FleetManager.Objects.headConfirmReenable", "Re-enable object", "Turbo.FleetManager.Objects.msgConfirmReenable", 'You are about to enable an object. Make sure that any active issues are resolved. And if so, close them so that they will not impact your performance negatively.');
        if (x) {
            await this.Api.get<any>("RentalObject/Enable", { objectId: item.Id });
            this.update();
        }
    }

  public update() {
    this.table.update();
    }

    public async registerIssue(item: RentalObjectInfo) {
        CreateServiceRequestDialog.open(this.Dialog, item.Id, item.RentalLocation.Id, item);
        this.update();
    }

    public async openObjectEditor(object: RentalObjectInfo = null, editable: boolean = true) {
        await this.Dialog.open(CreateObjectDialog, { width: '850px', data: { addonToChange: object ? object : false, editable: editable } }).afterClosed().toPromise();
        this.update();
    }

    public async open(item: RentalObjectInfo) {
      var x = await ObjectDialog.open(this.Dialog, item);
      this.update();
    }

    public async removeObject(item: RentalObjectInfo) {
        var x = await this.UI.confirm("Turbo.FleetManager.Objects.headConfirmDeletion", "Remove object", "Turbo.FleetManager.Objects.msgDeletion", 'Are you sure that you want to remove this trailer from your fleet?');
        if (x) {
            await this.Api.post<any>("RentalObject/DeleteObject", null, { objectId: item.Id });
            this.update();
        }
    }

}
